import React, { useState } from 'react'

import { emptyTextArea } from 'types/editor'

import { Comment as CommentType } from 'services/apiTypes/comment.types'

import CommentService from 'services/comment.service'
import ToastService from 'services/toast.service'

import Editor from 'components/formElements/richText/Editor'

type Props = {
  show: boolean
  parentComment: CommentType
  onClose: () => void
  onReplySubmitted: (newComment: CommentType) => void
  className?: string
}

const CommentReplyForm = ({ show, parentComment, onClose, onReplySubmitted, className }: Props) => {
  const [editor, setEditor] = useState<string>(emptyTextArea)

  const handleSubmit = () => {
    return CommentService.createComment(parentComment.id, editor)
      .then(newComment => {
        // We're adding the new comment as the first child to the comment being replied to (so it appears at the top)
        // In reality, if they refresh it'll sort to where it belongs, but the faking it at post time is a nicity for the user
        const updatedComment: CommentType = {
          ...parentComment,
          children: [newComment, ...parentComment.children],
          childrenCount: parentComment.childrenCount + 1,
        }

        setEditor(emptyTextArea)
        onReplySubmitted(updatedComment)
        onClose()
      })
      .catch(err => ToastService.create(err, 'Comment Service', 'error'))
  }

  if (!show) return null

  return (
    <div className={className} style={{ marginTop: '.5rem' }}>
      <Editor
        autofocus
        placeholder="Reply to ..."
        value={editor}
        onChange={setEditor}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </div>
  )
}

export default CommentReplyForm
